module.exports = __webpack_public_path__ + "static/media/345697.25d5d039.svg";